import { GridCellProps } from '@progress/kendo-react-grid';
import { useCallback, useContext, useMemo } from 'react';
import GridCellBase from 'src/components/GridCellBase';
import { EditCellContext } from 'src/contexts/EditCellContext';
import { informationIcon } from 'src/utils/icons';

const DepartmentMembers = (props: GridCellProps) => {
  const [cellClick] = useContext(EditCellContext);
  const { handleGLCodesOrMemberClick } = cellClick?.('');
  const { dataItem, field = '' } = props;
  const members = useMemo(() => dataItem?.[field] || [], [dataItem, field]);
  const handleClick = useCallback(
    (e: any) => {
      e.stopPropagation();
      handleGLCodesOrMemberClick?.({
        data: { members, departmentName: dataItem?.name || '' },
        type: field,
      });
    },
    [handleGLCodesOrMemberClick, dataItem?.name, field, members]
  );

  return (
    <GridCellBase {...props} rowSelectionEnabled disableToolTip>
      <div className="flex justify-center items-center cursor-pointer">
        <span className="w-[90px]"> {members.length} Members</span>

        <div onClick={handleClick}>{informationIcon}</div>
      </div>
    </GridCellBase>
  );
};

export default DepartmentMembers;
